<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="">
            <dl class="row">
                <!-- Brand -->
                <dt class="col-md-3">
                    Bandeira
                </dt>
                <dd class="col-md-9">
                    {{ card.brand }}
                </dd>

                <!-- Holder Name -->
                <dt class="col-md-3">
                    Nome do Titular
                </dt>
                <dd class="col-md-9">
                    {{ card.holder_name }}
                </dd>

                <!-- Last Four Digits -->
                <dt class="col-md-3">
                    Número
                </dt>
                <dd class="col-md-9">
                    **** **** **** {{ card.last_four_digits }}
                </dd>

                <!-- Expiration -->
                <dt class="col-md-3">
                    Data de Expiração
                </dt>
                <dd class="col-md-9">
                    {{ card.exp_month }}/{{ card.exp_year }}
                </dd>

                <!-- Status -->
                <dt class="col-md-3">
                    Status
                </dt>
                <dd class="col-md-9">
                    <span v-if="card.status === 'active'">
                        Ativo
                    </span>
                    <span v-if="card.status === 'deleted'">
                        Removido
                    </span>
                    <span v-if="card.status === 'expired'">
                        Expirado
                    </span>
                </dd>
            </dl>
        </div>
    </b-overlay>
</template>

<script>
export default {
    props: {
        card: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
        }
    }
}
</script>

<style scoped>

</style>
